import { createContext } from 'react';

const PermissionContext = createContext({
    loading: true,
    plugins: [],
    authenticated: false,
    roles: []
});

export { PermissionContext };
//# sourceMappingURL=context.js.map
